import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemTextField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const CareerHighlightsEditor = () => {
  const { networkingBriefDocument: { careerHighlights } = {} } =
    useNetworkingBrief()
  const { t } = useTranslation('CareerHighlightsEditor')

  return (
    <EditorItemProvider sectionName="careerHighlights" item={careerHighlights}>
      <div>
        <EditorHeading>{t('career_highlights')}</EditorHeading>
        <p> {t('top_professional_achievements')}</p>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemTextField
            containerClassName="md:col-span-2"
            fieldName="professionalAchievements"
            label={t('professional_achievements_statement')}
            areaClassName="h-[150px]"
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default CareerHighlightsEditor
